/* global window */

var ReactDOM = require('react-dom');

import { Provider } from 'react-redux';
import React from 'react';
import { createStore, applyMiddleware, combineReducers } from 'redux';

import thunk from 'redux-thunk';

import { gateReducer, barProfitInputReducer } from './BarProfitInput/reducers/reducer'
import { barProfitReportReducer } from './BarProfitReport/reducers/reducer'

import BarProfitTool from './BarProfitTool'

import {ActionTypes as barProfitInputActionTypes} from './BarProfitInput/actions/actions'

require('../../shared/css/base.scss');

const sessionInitialState = {};
const unauthenticatedSessionReducer = (state = sessionInitialState, action) => {
    let newState;

    switch (action.type) {
        case barProfitInputActionTypes.UNAUTHENTICATED_USER_SESSION_ID_ACQUIRED:
            newState = {...state};
            newState.sessionId = action.sessionId;
            return newState;

        default:
            return state
    }
};

const barProfitToolReducer = combineReducers({
    gate: gateReducer,
    barProfitInput: barProfitInputReducer,
    barProfitReport: barProfitReportReducer,
    unauthenticatedSession: unauthenticatedSessionReducer,
});

const store = createStore(barProfitToolReducer, applyMiddleware(thunk));

ReactDOM.render(
    <Provider store={ store }>
        <BarProfitTool></BarProfitTool>
    </Provider>,
    document.getElementById("bar-profit-tool")
);

$(function() {
    $.localScroll({
        lazy: true,
        duration: 1000,
        offset: 0,
    });
});